import { styles } from '~/components/HeaderFooter/styles.ts';
import { Container, Grid, Typography } from '@mui/material';

export const FooterBlock = () => {
  return (
    <Grid container component="footer" sx={styles.containerFooter}>
      <Container maxWidth="xl" disableGutters>
        <Grid container sx={styles.gridContainer}>
          <Grid>
            <Typography variant="h6" sx={styles.titleH}>
              Київ, вул. Антоновича, 127
            </Typography>
            <Typography variant="body2" sx={styles.titleP}>
              contact@eximb.com
            </Typography>
          </Grid>
          <Typography variant="h6" sx={styles.titleNumber}>
            0-800-50-44-50
          </Typography>
        </Grid>
      </Container>
    </Grid>
  );
};
